export class FAQModule {
    faqid: number = 0;
    titleAr: string = '';
    titleEn: string = '';
    detailsAr: string = '';
    detailsEn: string = '';
    isVisible: boolean = true;
    categoryID: number = 0;
}
